import { createFileRoute } from "@tanstack/react-router"

import { DependencyMapPanel } from "@/pages/DependencyMapPanel"

export const Route = createFileRoute("/operations/dependencies")({
  component: DependencyMapPanel,
})
